import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Box, Card } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import useQuery from '@masfront/common-csr/router/hooks/useQuery'

import MainLoggedPage from '../pages/MainLoggedPage'

import { selectAgent } from '~/auth/store/auth.selectors'
import { useBrand, Brand } from '~/brand'
import { selectFeatureFlag, Flags } from '~/featureFlags'
import { HeaderContainer } from '~/home'
import usePermissions from '~/permissions/hooks/usePermissions'
import { CustomCircularProgress, ErrorMessage } from '~/ui/components'

const useStyles = makeStyles((theme) => {
  return {
    spinner: { margin: theme.spacing(60) },
    errorMessageCard: {
      height: '300px',
      borderRadius: '14px',
      padding: '30px 70px',
      borderBottom: `4px solid ${theme?.palette.error.main}`,
      width: '936px',
    },
  }
})

interface ParamsProps {
  customerIdentifier?: string
}

const MainLoggedPageWrapper: React.FC = () => {
  const classes = useStyles()
  const { brand, setBrand } = useBrand()
  const query = useQuery()
  const brandInQuery = query.get('brand')
  const { customerIdentifier }: ParamsProps = useParams()
  const { getPermissions, permissions, error, loading } = usePermissions()
  const { agent } = useSelector(selectAgent)

  const isPermissionsActiveFlag = useSelector(selectFeatureFlag(Flags.isPermissionsActive))

  // Brand changed?
  const brandChanging = brandInQuery && (brandInQuery as Brand) !== brand

  useEffect(() => {
    if (brandInQuery && Object.values(Brand).includes(brandInQuery as Brand)) {
      setBrand(brandInQuery as Brand)
    }
    getPermissions({ brand, sub: agent?.sub })
  }, [brandInQuery, isPermissionsActiveFlag])

  return (
    <>
      {loading && (
        <Box width="100%" display="flex" justifyContent="center">
          <Box className={classes.spinner}>
            <CustomCircularProgress size={100} />
          </Box>
        </Box>
      )}

      {!loading && !brandChanging && permissions && (
        <Box>
          <HeaderContainer permissions={permissions} />
          {permissions.length > 0 ? (
            <MainLoggedPage customerIdentifier={customerIdentifier} />
          ) : (
            <Box width="100%" mt={50} display="flex" justifyContent="center">
              <Card className={classes.errorMessageCard}>
                <ErrorMessage title="No tiene permisos para realizar esta acción." />
              </Card>
            </Box>
          )}
        </Box>
      )}

      {error && (
        <Box width="100%" mt={50} display="flex" justifyContent="center">
          <Card className={classes.errorMessageCard}>
            <ErrorMessage title="Ha ocurrido un error." subtitle="Por favor, inténtalo de nuevo." />
          </Card>
        </Box>
      )}
    </>
  )
}

export default MainLoggedPageWrapper
